import Nullstack from 'nullstack';
export default function IconLemon({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-lemon",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17.536 3.393c3.905 3.906 3.905 10.237 0 14.143c-3.906 3.905 -10.237 3.905 -14.143 0l14.143 -14.143"
  }), "   ", Nullstack.element("path", {
    d: "M5.868 15.06a6.5 6.5 0 0 0 9.193 -9.192"
  }), "   ", Nullstack.element("path", {
    d: "M10.464 10.464l4.597 4.597"
  }), "   ", Nullstack.element("path", {
    d: "M10.464 10.464v6.364"
  }), "   ", Nullstack.element("path", {
    d: "M10.464 10.464h6.364"
  }), " ");
}